import { render, staticRenderFns } from "./configDialog.vue?vue&type=template&id=db45fc46&scoped=true"
import script from "./configDialog.vue?vue&type=script&lang=js"
export * from "./configDialog.vue?vue&type=script&lang=js"
import style0 from "./configDialog.vue?vue&type=style&index=0&id=db45fc46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db45fc46",
  null
  
)

export default component.exports